import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { ShortCourse } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Add to users wishlist
 * @param courseId
 */
const addUserWishlist = (courseId: string): Promise<ShortCourse[]> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.USER_WISHLIST
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = { courseId }
    AxiosClient.put(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default addUserWishlist
